// extracted by mini-css-extract-plugin
var _1 = "UserMenuNameNav-modulelink__WJpMS";
export { _1 as "link" }
